<div class="bg-red-50 border border-red-100 text-red-700 px-4 py-3 mb-5 rounded relative" role="alert">
  <span class="absolute top-2/4 translate-y-[-50%] right-4" (click)="onClose()">
    <i-tabler
      name="x"
      class="icon-24 w-8 d-flex rounded cursor-pointer aspect-square"
    />
  </span>

  <h6 class="font-semibold d-flex items-center gap-2">
    <i-tabler class="icon-20 mr-[2px]" name="exclamation-circle"></i-tabler>
    <p class="text-sx">{{ title | translate }} ({{ totalErrors }})</p>
  </h6>
  <p class="mt-1 ml-6 text-sm">{{ 'import process errors message' | translate:{ count: totalErrors } }}</p>
</div>

<app-data-table
  tableId="import-process-errors-table"
  [tableConfig]="tableConfig"
  [dataSource]="errors"
/>
